import { useMemo } from "react";

import { useSelector } from "react-redux";

import companyAnalysisTrackingService from "app/pages/sales-intelligence/modules/company-analysis/services/tracking/companyAnalysisTrackingService";
import { useFetchOpportunityListsIfNotPresent } from "app/pages/sales-intelligence/sub-modules/opportunities/hooks/useFetchOpportunityListsIfNotPresent";
import useStaticListSizeQuota from "app/pages/sales-intelligence/hooks/useStaticListSizeQuota";

import AddWebsiteToListButton from "./AddWebsiteToListButton";
import { selectAlreadyInList, selectDisabledListNames } from "./selectors";

const AddWebsiteToListButtonContainer = ({ domain, onClick }: { domain: string; onClick?: () => void }) => {
    const { isListSizeQuotaReached } = useStaticListSizeQuota();

    const disabledListsSelector = useMemo(() => selectDisabledListNames(domain), [domain]);
    const listsWithDomainSelector = useMemo(() => selectAlreadyInList(domain), [domain]);
    const disabledListsNames = useSelector(disabledListsSelector);
    const listsWithDomain = useSelector(listsWithDomainSelector);

    useFetchOpportunityListsIfNotPresent();

    const handleButtonClick = () => {
        companyAnalysisTrackingService.overview.trackAddToListClick(listsWithDomain?.length);
        onClick?.();
    };

    const handleButtonHover = () => {
        companyAnalysisTrackingService.overview.trackAddToListHover(listsWithDomain?.length);
    };

    const handleHookButtonClick = () => {
        companyAnalysisTrackingService.overview.trackAddToListHookClick();
    };

    return (
        <AddWebsiteToListButton
            domain={domain}
            onButtonClick={handleButtonClick}
            onButtonHover={handleButtonHover}
            listsWithDomain={listsWithDomain}
            isDisabled={isListSizeQuotaReached}
            disabledListsNames={disabledListsNames}
            isListSizeQuotaReached={isListSizeQuotaReached}
            onHookButtonClick={handleHookButtonClick}
        />
    );
};

export default AddWebsiteToListButtonContainer;
